import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import favorite from '@gin-betting/favorite';
import core from '@gin-betting/core';

import ToggleFavoriteButton from './ToggleFavoriteButton';

interface OwnProps {
    matchId: string;
}

interface MappedProps {
    isActive: ReturnType<typeof selectIsFavoriteSportEvent>;
}

interface MappedActions {
    addMatchToFavoriteRequest: typeof addMatchToFavoriteRequest;
    addMatchToFavoriteLocal: typeof addMatchToFavoriteLocal;
    deleteMatchFromFavoriteRequest: typeof deleteMatchFromFavoriteRequest;
    deleteMatchFromFavoriteLocal: typeof deleteMatchFromFavoriteLocal;
}

type Props = OwnProps & MappedProps & MappedActions;

const {
    utils: { getBettingOptions },
} = core;

const {
    actions: {
        addMatchToFavoriteRequest,
        addMatchToFavoriteLocal,
        deleteMatchFromFavoriteRequest,
        deleteMatchFromFavoriteLocal,
    },
    selectors: { selectIsFavoriteSportEvent },
} = favorite;

class ToggleFavoriteButtonContainer extends React.Component<Props> {
    handleAddFavorite = () => {
        const { matchId } = this.props;
        const { isAuthorized } = getBettingOptions();

        if (isAuthorized) {
            this.props.addMatchToFavoriteRequest({ favoriteId: matchId });
        } else {
            this.props.addMatchToFavoriteLocal({ favoriteId: matchId });
        }
    };

    handleDeleteFavorite = () => {
        const { matchId } = this.props;
        const { isAuthorized } = getBettingOptions();

        if (isAuthorized) {
            this.props.deleteMatchFromFavoriteRequest({ favoriteId: matchId });
        } else {
            this.props.deleteMatchFromFavoriteLocal({ favoriteId: matchId });
        }
    };

    toggleFavorite = () => {
        const { isActive } = this.props;

        if (isActive) {
            this.handleDeleteFavorite();
        } else {
            this.handleAddFavorite();
        }
    };

    render() {
        const { isActive } = this.props;

        return React.createElement(ToggleFavoriteButton, {
            isActive,
            toggle: this.toggleFavorite,
        });
    }
}

const mapStateToProps = createStructuredSelector({
    isActive: selectIsFavoriteSportEvent,
});

const mapDispatchToProps: MappedActions = {
    addMatchToFavoriteRequest,
    addMatchToFavoriteLocal,
    deleteMatchFromFavoriteRequest,
    deleteMatchFromFavoriteLocal,
};

export default connect<MappedProps, MappedActions, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(ToggleFavoriteButtonContainer);
